module.exports = __webpack_public_path__ + "static/media/newlook.636fff90.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/newlook.png
// module id = 228
// module chunks = 0